import React, { useState, useEffect, useRef } from "react";
import logoImg from "../../../assets/images/logo-img.png";
import { useTranslation } from "react-i18next";
import moment from "moment";
import AdminJewelryReportService from "../../../services/admin-jewelryReport-service";
import { useSelector } from "react-redux";
import { Button, DatePicker, Modal, Select, Spin, Table, Tooltip } from "antd";
import Chart from "react-google-charts";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { BlobToDownloadFile } from "../../../helper/commanFunction";
import { chartColors } from "../../reports/colors";

/*Initial State for Binding Starts*/
const initialEventState = {
  dealerID: "",
  forDealer: "",
  fromDate: moment().subtract(30, "days"),
  toDate: moment(),
  retailerIds: [],
  vendorIds: [],
  price: "",
  price1: "",
  price2: "",
};

/*Initial State for Binding Ends*/
const { RangePicker } = DatePicker;
const { Option } = Select;

const JewelryPriceReport = () => {
  const { t } = useTranslation();
  const [selectedData, setSelectedData] = useState(initialEventState);
  const [vendorList, setVendorList] = useState([]);
  const [retailerList, setRetailerList] = useState([]);
  const [tableChartData, setTableChartData] = useState([]);
  const [priceRange, setpriceRange] = useState([]);
  const [priceTotal, setPriceTotal] = useState([]);
  const [priceTotalValuePercentage, setPriceTotalValuePercentage] = useState(0);
  const [showChart, setShowChart] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [visible, setVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState();
  const loginDetials = useSelector((state) => state.loginReducer);
  const [showTableLoader, setShowTableLoader] = useState(true);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [totalCount, setTotalCount] = useState(0);
  const [sortType, setSortType] = useState("desc");
  const [CSVLoading, setCSVLoading] = useState(false);
  const data1 = [];
  const [key, setKey] = useState(true);
  
  // Google Charts related states
  const [googleChartData, setGoogleChartData] = useState([]);
  const [colorData, setColorData] = useState([]);
  const [processedChartData, setProcessedChartData] = useState([]);
  
  // Add max entries constant
  const MAX_ENTRIES = 15;

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setSelectedData((prevState) => ({
            ...prevState,
            dealerID: loginDetials.loginDetials.responseData.dealerId,
          }));
        }
      }
    }
    handleGetForDealer(loginDetials.loginDetials.responseData.dealerId);
    handleGetVendorDropdownData();
    handleGetRetailerDropdownData();
  }, []);

  // Prepare chart data with max entries limit
  const prepareChartData = (ranges, counts) => {
    const total = counts.reduce((a, b) => a + Number(b), 0);

    // Pair labels and data together
    const labeledData = ranges.map((label, idx) => ({
      label,
      value: Number(counts[idx]),
      percent: total > 0 ? (Number(counts[idx]) / total) * 100 : 0,
    }));

    // Sort descending by value
    const sorted = [...labeledData].sort((a, b) => b.value - a.value);

    // Split top and remaining
    const topData = sorted.slice(0, MAX_ENTRIES);
    const remainingData = sorted.slice(MAX_ENTRIES);

    // Sum "Others"
    const othersValue = remainingData.reduce((sum, d) => sum + d.value, 0);

    // If there are remaining values, push an "Others" slice
    if (othersValue > 0) {
      topData.push({
        label: t("Others"),
        value: othersValue,
        percent: total > 0 ? (othersValue / total) * 100 : 0,
      });
    }

    // Prepare rows for Google Chart
    const rows = [["Label", "Value"]];
    topData.forEach((item) => {
      const labelWithPercent = `${item.label} (${item.percent.toFixed(2)}%)`;
      rows.push([labelWithPercent, item.value]);
    });

    // Assign consistent colors
    const colors = topData.map((_, i) => chartColors[i % chartColors.length]);

    return { chartData: rows, colors, processedData: topData };
  };

  const handleGetForDealer = (id) => {
    const initialEventState = {
      dealerID: id,
    };
    setShowLoader(true);
    AdminJewelryReportService.GetForDealer(initialEventState).then(
      (response) => {
        let message = response.data.message;
        let responseData = response.data.responseData;
        if (message === "Success") {
          setSelectedData((prevState) => ({
            ...prevState,
            forDealer: responseData.forDealer,
          }));

          handleGetClicksBasedOnPrice(id, responseData.forDealer);
          handleGetTableChartData(id, responseData.forDealer);
        }
      }
    );
  };

  const handleGetClicksBasedOnPrice = (DealerId, forDealerId) => {
    const initialEventState = {
      dealerID: DealerId,
      forDealer: forDealerId,
      fromDate: selectedData.fromDate
        ? moment(selectedData.fromDate).format("YYYY-MM-DD")
        : "2020-08-17",
      toDate: selectedData.toDate
        ? moment(selectedData.toDate).format("YYYY-MM-DD")
        : "2022-09-15",
      retailerIds: selectedData.retailerIds.toString(),
      vendorIds: selectedData.vendorIds.toString(),
    };
    setPriceTotal([]);
    setpriceRange([]);
    setShowLoader(true);
    AdminJewelryReportService.GetClicksBasedOnPrice(initialEventState)
      .then((response) => {
        let message = response.data.message;
        let responseData = response.data.responseData;
        if (message === "Success") {
          let showResp = responseData.every((element) => {
            return element.total == "0";
          });
          setShowChart(showResp);
          let range = [];
          let total = [];
          for (let i of responseData) {
            range.push(i.range);
            total.push(i.total);
          }
          let totalValuePercentage = total.reduce(
            (a, b) => (a = Number(a) + Number(b)),
            0
          );
          setPriceTotal(total);
          setpriceRange(range);
          setPriceTotalValuePercentage(totalValuePercentage);
          setKey(!key);

          // Process data for Google Charts
          const { chartData, colors, processedData } = prepareChartData(range, total);
          setGoogleChartData(chartData);
          setColorData(colors);
          setProcessedChartData(processedData);
        }
      })
      .catch((e) => console.log(e))
      .finally(() => {
        setShowLoader(false);
      });
  };

  const handleGetTableChartData = async (
    DealerId,
    forDealerId,
    type,
    pageNo,
    pageSize,
    sortColumn,
    sorttype
  ) => {
    const initialEventState = {
      dealerID: DealerId,
      forDealer: forDealerId,
      fromDate: selectedData.fromDate,
      toDate: selectedData.toDate,
      retailerIds: selectedData.retailerIds.toString(),
      vendorIds: selectedData.vendorIds.toString(),
      category: "",
      metalType: "",
      metalColorType: "",
      price: selectedData.price,
      price1: selectedData.price1?.trim().toString() || "",
      price2: selectedData.price2?.trim().toString() || "",
      vendor: "",
      retailer: "",
      reporttype: "Global",
      pageIndex: pageNo ? pageNo : 1,
      pageSize: pageSize ? pageSize : 15,
      sortColumnName:
        sortColumn == "UserIPAddress"
          ? "UserIPAddress"
          : sortColumn == "Vendor"
          ? "VendorName"
          : sortColumn == "Retailer"
          ? "RetailerName"
          : sortColumn == "Collection"
          ? "CollectionNew"
          : sortColumn == "Category"
          ? "Category"
          : sortColumn == "Date"
          ? "Date"
          : sortColumn == "StyleNumber"
          ? "StyleNumber"
          : sortColumn == "MetalType"
          ? "MetalType"
          : sortColumn == "MetalColor"
          ? "MetalColor"
          : sortColumn == "Price"
          ? "Price"
          : "date",
      sortOrder: sorttype ? sorttype.toString() : sortType.toString(),
    };
    setShowTableLoader(true);
    AdminJewelryReportService.GetTableChartData(initialEventState)
      .then((response) => {
        let message = response.data.message;
        let responseData = response.data.responseData;
        if (message === "Success") {
          setTotalCount(responseData?.[0]?.totalRecords || 0);
          const newData = [];
          responseData.map((elem, index) => {
            newData.push({
              key: index,
              ProductImage: (
                <span onClick={() => imageClickHandler(elem.imagePathNew)}>
                  <img src={elem.imagePathNew} className="product__img" />
                </span>
              ),
              UserIPAddress: <span>{elem.userIPAddress}</span>,
              Vendor: (
                <span>{elem.vendorName === null ? "" : elem.vendorName}</span>
              ),
              Retailer: (
                <span>
                  {elem.retailerName === null ? "" : elem.retailerName}
                </span>
              ),
              Collection: <span>{elem.collectionNew}</span>,
              Category: <span>{elem.category}</span>,
              Date: <span>{elem.dateTime}</span>,
              StyleNumber: <span>{elem.styleNumber}</span>,
              MetalType: <span>{elem.metalType}</span>,
              MetalColor: <span>{elem.metalColor}</span>,
              Price: <span>{elem.price}</span>,
            });
          });
          setTableChartData(newData);
        } else {
          setTotalCount(0);
          setTableChartData([]);
        }
      })
      .catch((e) => console.log(e))
      .finally(() => {
        setShowTableLoader(false);
      });
  };

  const handleDownloadCSVReports = async () => {
    const initialEventState = {
      dealerID: selectedData?.dealerID,
      forDealer: selectedData.forDealer,
      fromDate: selectedData.fromDate,
      toDate: selectedData.toDate,
      retailerIds: selectedData.retailerIds.toString(),
      vendorIds: selectedData.vendorIds.toString(),
      category: "",
      metalType: "",
      metalColorType: "",
      price: selectedData.price,
      price1: selectedData.price1?.trim().toString() || "",
      price2: selectedData.price2?.trim().toString() || "",
      vendor: "",
      retailer: "",
      reporttype: "Global",
      pageIndex: pageNo ? pageNo : 1,
      pageSize: pageSize ? pageSize : 15,
      sortColumnName: "date",
      sortOrder: "asc",
    };
    setCSVLoading(true);
    AdminJewelryReportService.JewelryReportForTableChartCSVDownload(initialEventState)
      .then((response) => {
        setCSVLoading(false);
        var fileName =
          "JewelryPrice_Report" +
          new Date().toJSON().slice(0, 10).split("-").reverse().join("/") +
          ".csv";
        BlobToDownloadFile(response.data, fileName);
      })
      .catch((error) => {
        setCSVLoading(false);
      });
  };

  const handleGetVendorDropdownData = () => {
    const dealerId = loginDetials.loginDetials.responseData.dealerId;
    let inputData = {
      dealerId: dealerId,
      reporttype: "Global",
    };
    AdminJewelryReportService.GetVendorDropdownList(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          setVendorList(responseData);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleGetRetailerDropdownData = () => {
    let inputData = {
      dealerId: 0,
      reporttype: "Global",
    };
    AdminJewelryReportService.GetRetailerDropdownList(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          setRetailerList(responseData);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /*DatePicker Binding Starts*/
  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setSelectedData((prevState) => ({
        ...prevState,
        fromDate: moment.utc(dates[0]).toISOString(),
        toDate: moment.utc(dates[1]).toISOString(),
      }));
    }
  };
  /*DatePicker Binding Ends*/

  const handleOnChange = (e, isSelect, name) => {
    if (isSelect === "select" && name === "vendors") {
      let vId = "";
      if (e.includes(0)) {
        vId = [0];
        setSelectedData((prevState) => ({
          ...prevState,
          vendorIds: vId,
        }));
      } else {
        vId = e;
        setSelectedData((prevState) => ({
          ...prevState,
          vendorIds: e,
        }));
      }
      if (e.length == 0 || e.includes(0)) {
        // When vendor cleared, check if retailer is still selected
        if (selectedData.retailerIds && selectedData.retailerIds.length > 0 && !selectedData.retailerIds.includes(0)) {
          changeVendorListHandler(selectedData.retailerIds);
        } else {
          handleGetVendorDropdownData();
          handleGetRetailerDropdownData();
        }
      } else {
        changeRetailerListHandler(vId);
      }
    } else if (isSelect === "select" && name === "retailers") {
      let rId = "";
      if (e.includes(0)) {
        rId = [0];
        setSelectedData((prevState) => ({
          ...prevState,
          retailerIds: rId,
        }));
      } else {
        rId = e;
        setSelectedData((prevState) => ({
          ...prevState,
          retailerIds: e,
        }));
      }
      if (e.length == 0 || e.includes(0)) {
        // When retailer cleared, check if vendor is still selected
        if (selectedData.vendorIds && selectedData.vendorIds.length > 0 && !selectedData.vendorIds.includes(0)) {
          changeRetailerListHandler(selectedData.vendorIds);
        } else {
          handleGetVendorDropdownData();
          handleGetRetailerDropdownData();
        }
      } else {
        changeVendorListHandler(rId);
      }
    }
  };

  const changeRetailerListHandler = (data) => {
    data = data.toString();
    let inputData = {
      vendorIds: data,
    };
    AdminJewelryReportService.ChangeRetailerList(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          setRetailerList(responseData);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const changeVendorListHandler = (data) => {
    data = data.toString();
    let inputData = {
      retailerIds: data,
    };
    AdminJewelryReportService.ChangeVendorList(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          setVendorList(responseData);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const applyFilterHandler = () => {
    var obj = selectedData;
    obj["price"] = "";
    obj["price1"] = "";
    obj["price2"] = "";
    setSelectedData((prevState) => ({
      ...prevState,
      price: "",
      price1: "",
      price2: "",
    }));
    setPageNo(1);
    handleGetClicksBasedOnPrice(selectedData.dealerID, selectedData.forDealer);
    handleGetTableChartData(selectedData.dealerID, selectedData.forDealer);
    setPageSize(15);
  };

  const imageClickHandler = (img) => {
    setVisible(true);
    setSelectedImage(img);
  };

  const columns = [
    {
      title: <Tooltip title={t("Product Image")}>{t("Product Image")}</Tooltip>,
      ellipsis: true,
      dataIndex: "ProductImage",
      showSorterTooltip: false,
    },
    {
      title: (
        <Tooltip title={t("User IP Address")}>{t("User IP Address")}</Tooltip>
      ),
      ellipsis: true,
      dataIndex: "UserIPAddress",
      sorter: (a, b) => {},
      showSorterTooltip: false,
    },
    {
      title: <Tooltip title={t("Vendor")}>{t("Vendor")}</Tooltip>,
      ellipsis: true,
      dataIndex: "Vendor",
      sorter: (a, b) => {},
      showSorterTooltip: false,
    },
    {
      title: <Tooltip title={t("Retailer")}>{t("Retailer")}</Tooltip>,
      ellipsis: true,
      dataIndex: "Retailer",
      sorter: (a, b) => {},
      showSorterTooltip: false,
    },
    {
      title: <Tooltip title={t("Collection")}>{t("Collection")}</Tooltip>,
      ellipsis: true,
      dataIndex: "Collection",
      sorter: (a, b) => {},
      showSorterTooltip: false,
    },
    {
      title: <Tooltip title={t("Category")}>{t("Category")}</Tooltip>,
      ellipsis: true,
      dataIndex: "Category",
      sorter: (a, b) => {},
      showSorterTooltip: false,
    },
    {
      title: <Tooltip title={t("Date")}>{t("Date")}</Tooltip>,
      ellipsis: true,
      dataIndex: "Date",
      defaultSortOrder: "descend",
      sorter: (a, b) => {},
      showSorterTooltip: false,
    },
    {
      title: <Tooltip title={t("Style Number")}>{t("Style Number")}</Tooltip>,
      ellipsis: true,
      dataIndex: "StyleNumber",
      sorter: (a, b) => {},
      showSorterTooltip: false,
    },
    {
      title: <Tooltip title={t("Metal Type")}>{t("Metal Type")}</Tooltip>,
      ellipsis: true,
      dataIndex: "MetalType",
      showSorterTooltip: false,
      sorter: (a, b) => {},
    },
    {
      title: <Tooltip title={t("Metal Color")}>{t("Metal Color")}</Tooltip>,
      ellipsis: true,
      dataIndex: "MetalColor",
      sorter: (a, b) => {},
      showSorterTooltip: false,
    },
    {
      title: <Tooltip title={t("Price")}>{t("Price")}</Tooltip>,
      ellipsis: true,
      dataIndex: "Price",
      sorter: (a, b) => {},
      showSorterTooltip: false,
      render: (Price) => (
        <Tooltip title={Price}>
          <span>{Price}</span>
        </Tooltip>
      ),
    },
  ];

  const tableSortHandler = (type) => {
    var obj = selectedData;
    let price = type == "Call For Price" ? type : "";
    let price1 = "",
      price2 = "";
    if (type && type !== "Call For Price") {
      price1 =
        type == "None"
          ? "-"
          : type.includes("Under")
          ? "0"
          : type.split("-")[0].split("$")[1];
      price2 =
        type == "None"
          ? "-"
          : type.includes("Under")
          ? type.split("$")[1]
          : type.split("-").length > 1
          ? type.split("-")[1].split("$")[1]
          : type;
    }
    obj["price"] = price;
    obj["price1"] = price1;
    obj["price2"] = price2;
    setSelectedData(obj);
    handleGetTableChartData(obj.dealerID, obj.forDealer, type);
  };

  const handleTableASCDES = (pagination, filters, sorter) => {
    var tableBody = document.querySelector(".pendjewelreq__tbl .ant-table-body"); if (tableBody) tableBody.scrollTop = 0;
    var type = "";
    var column = "";

    if (sorter.order == "descend") {
      type = "DESC";
      column = sorter.field;
      setSortType(type);
    } else if (sorter.order == "ascend") {
      type = "ASC";
      column = sorter.field;
      setSortType(type);
    } else {
      type = "DESC";
      column = "date";
      setSortType(type);
    }
    setPageNo(pagination.current);
    setPageSize(pagination.pageSize);
    handleGetTableChartData(
      selectedData.dealerID,
      selectedData.forDealer,
      "",
      pagination.current,
      pagination.pageSize,
      column,
      type
    );
  };

  // Chart click handler
  const handleChartClick = ({ chartWrapper }) => {
    const chart = chartWrapper.getChart();
    const selection = chart.getSelection();
    if (selection.length > 0) {
      const selectedItem = selection[0];
      const label = googleChartData[selectedItem.row + 1][0];
      const result = label.split(" (")[0];
      tableSortHandler(result);
      setPageNo(1);
    }
  };

  // Chart options
  const chartOptions = {
    pieHole: 0.5,
    is3D: true,
    chartArea: { width: "100%", height: "100%" },
    pieSliceText: "percentage",
    legend: {
      position: "none", // Hide default legend since we have custom one
    },
    tooltip: { isHtml: true },
    colors: colorData,
  };

  // Enhanced PDF download function
  const handleDownloadPieChart = async () => {
    try {
      // ------------ 1. High-Res Chart Setup -----------------
      const pdfChartOptions = {
        ...chartOptions,
        width: 1800,
        height: 950,
        chartArea: { left: 50, top: 140, width: "100%", height: "100%" },
        legend: { position: "none" },
        pieHole: 0.4,
        pieSliceText: "percentage",
        tooltip: { text: "percentage" },
        pieSliceTextStyle: { fontSize: 18, color: "#000" },
      };

      // ------------ 2. Hidden DOM Container -----------------
      const hiddenContainer = document.createElement("div");
      hiddenContainer.id = "pdf-temp-piechart";
      hiddenContainer.style.position = "absolute";
      hiddenContainer.style.left = "-9999px";
      hiddenContainer.style.top = "0";
      hiddenContainer.style.width = "1800px";
      hiddenContainer.style.background = "#fff";
      hiddenContainer.style.padding = "20px";
      document.body.appendChild(hiddenContainer);

      // ------------ 3. Custom Legends -----------------
      const legendDiv = document.createElement("div");
      legendDiv.style.display = "flex";
      legendDiv.style.flexWrap = "wrap";
      legendDiv.style.justifyContent = "flex-start";
      legendDiv.style.marginBottom = "20px";
      legendDiv.style.fontFamily = "Arial, sans-serif";
      legendDiv.style.width = "100%";

      googleChartData.slice(1).forEach((row, index) => {
        const item = document.createElement("div");
        item.style.display = "flex";
        item.style.alignItems = "center";
        item.style.margin = "8px 16px";
        item.style.fontSize = "16px";
        item.style.fontWeight = "bold";
        item.style.whiteSpace = "nowrap";

        const colorBox = document.createElement("div");
        colorBox.style.width = "18px";
        colorBox.style.height = "18px";
        colorBox.style.backgroundColor = colorData[index];
        colorBox.style.marginRight = "8px";
        colorBox.style.border = "1px solid #aaa";
        colorBox.style.borderRadius = "3px";

        const labelText = row[0].replace(/\s*\([^)]*\)\s*/g, "");
        const valueText = ` (${row[1]})`;

        const textNode = document.createTextNode(labelText + valueText);
        item.appendChild(colorBox);
        item.appendChild(textNode);
        legendDiv.appendChild(item);
      });

      hiddenContainer.appendChild(legendDiv);

      // ------------ 4. Draw Chart -----------------
      const chartDiv = document.createElement("div");
      chartDiv.style.width = "1800px";
      chartDiv.style.height = "900px";
      hiddenContainer.appendChild(chartDiv);

      const tempChart = new window.google.visualization.PieChart(chartDiv);
      const dataTable = window.google.visualization.arrayToDataTable(googleChartData);

      await new Promise((resolve) => {
        window.google.visualization.events.addListener(tempChart, "ready", resolve);
        tempChart.draw(dataTable, pdfChartOptions);
      });

      // ------------ 5. Convert to Canvas -----------------
      const canvas = await html2canvas(hiddenContainer, {
        useCORS: true,
        scale: 2.8,
        logging: false,
      });
      const imgData = canvas.toDataURL("image/png");
      document.body.removeChild(hiddenContainer);

      // ------------ 6. Setup PDF -----------------
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 5;
      const headerHeight = 14;
      const footerHeight = 10;

      // ------------ 7. Header -----------------
      pdf.setFillColor(31, 38, 62);
      pdf.rect(0, 0, pageWidth, headerHeight, "F");
      try {
        pdf.addImage(logoImg, "PNG", margin, 4, 40, 10);
      } catch { }

      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(14);
      pdf.setTextColor(255, 255, 255);
      pdf.text("JEWELRY PRICE REPORT", pageWidth - margin, 11, {
        align: "right",
      });

      // ------------ 8. Dynamic Info Block -----------------

      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(9);
      pdf.setTextColor(0, 0, 0);

      const normalizeIds = (arr) => arr.map((id) => Number(id));
      const vendorIds = normalizeIds(selectedData.vendorIds);
      const retailerIds = normalizeIds(selectedData.retailerIds);

      const selectedVendorNames =
        vendorIds.length === 0
          ? "All Vendors"
          : vendorList
            .filter((v) => vendorIds.includes(Number(v.dealerID)))
            .map((v) => v.dealerCompany)
            .join(", ");

      const selectedRetailerNames =
        retailerIds.length === 0
          ? "All Retailers"
          : retailerList
            .filter((v) => retailerIds.includes(Number(v.dealerID)))
            .map((v) => v.dealerCompany)
            .join(", ");

      const preparedFor =
        loginDetials?.impresonateData
          ? `Prepared For: ${loginDetials.impresonateData.username} (${loginDetials.impresonateData.dealerID})`
          : loginDetials?.loginDetials?.responseData
            ? `Prepared For: ${loginDetials.loginDetials.responseData.dealerCompany} (${loginDetials.loginDetials.responseData.dealerId})`
            : "Prepared For: -";

      const dateRange = `Date Range: ${moment(selectedData.fromDate).format(
        "MMM DD, YYYY"
      )} - ${moment(selectedData.toDate).format("MMM DD, YYYY")}`;

      const infoLinesRaw = [
        preparedFor,
        dateRange,
        ...(loginDetials.loginDetials.responseData.dealerMemberTypeName === "Admin"
          ? [
            `Vendors: ${selectedVendorNames}`,
            `Retailers: ${selectedRetailerNames}`
          ]
          : loginDetials.loginDetials.responseData.dealerMemberTypeName === "Vendor"
            ? [`Retailers: ${selectedRetailerNames}`]
            : [`Vendors: ${selectedVendorNames}`]
        )
        
      ].filter(Boolean);

      const maxWidth = pageWidth - margin * 2;

      // split text dynamically
      const wrappedInfoLines = infoLinesRaw.flatMap((line) =>
        pdf.splitTextToSize(line, maxWidth)
      );

      const lineHeight = 4.8;
      let currentY = headerHeight + 5;

      wrappedInfoLines.forEach((line) => {
        pdf.text(line, margin, currentY);
        currentY += lineHeight;
      });

      currentY += 4;

      // ------------ 9. Insert Chart Below Dynamic Text -----------------

      const imgRatio = canvas.width / canvas.height;
      const availableHeight = pageHeight - currentY - footerHeight - 5;

      let imgWidthMM = pageWidth - margin * 2;
      let imgHeightMM = imgWidthMM / imgRatio;

      if (imgHeightMM > availableHeight) {
        imgHeightMM = availableHeight;
        imgWidthMM = imgHeightMM * imgRatio;
      }

      pdf.addImage(
        imgData,
        "PNG",
        margin,
        currentY,
        imgWidthMM,
        imgHeightMM,
        undefined,
        "FAST"
      );

      // ------------ 10. Footer -----------------

      pdf.setFillColor(31, 38, 62);
      pdf.rect(
        0,
        pageHeight - footerHeight,
        pageWidth,
        footerHeight,
        "F"
      );

      pdf.setTextColor(255, 255, 255);
      pdf.setFont("helvetica", "italic");
      pdf.setFontSize(8);

      const footerText = `© ${new Date().getFullYear()} JewelCloud Inc. | Generated on ${moment().format(
        "MMM DD, YYYY h:mm A"
      )}`;

      pdf.text(footerText, pageWidth / 2, pageHeight - 5, {
        align: "center",
      });

      // ------------ 11. Watermark -----------------

      const watermarkText = "JewelCloud";
      pdf.setFontSize(90);
      pdf.setFont(undefined, "bolditalic");
      pdf.setTextColor(102, 102, 102);

      pdf.saveGraphicsState();
      pdf.setGState(pdf.GState({ opacity: 0.1 }));

      const centerX = pageWidth / 2;
      const centerY = pageHeight / 2;

      const textWidth = pdf.getTextWidth(watermarkText);
      const textHeight =
        pdf.internal.getFontSize() / pdf.internal.scaleFactor;

      const angleRad = (45 * Math.PI) / 180;
      const rotatedWidth =
        textWidth * Math.cos(angleRad) + textHeight * Math.sin(angleRad);
      const rotatedHeight =
        textWidth * Math.sin(angleRad) + textHeight * Math.cos(angleRad);

      const xPosWatermark = centerX - rotatedWidth / 2;
      const yPosWatermark = centerY + rotatedHeight / 4 + 40;

      pdf.text(watermarkText, xPosWatermark, yPosWatermark, { angle: 45 });
      pdf.restoreGraphicsState();

      // ------------ 12. SAVE -----------------

      pdf.save("Jewelry-Price-Report.pdf");

    } catch (err) {
      console.error("Error generating Jewelry Category PDF:", err);
    }
  };

  return (
    <React.Fragment>
      <div className="pendjewelreq__section form__fields">
        <div className="row magento__mapping">
          <div className="col-md-12">
            <div className="heading__block">
              <h4 class="workarea__heading mt-0 mb-0">
                {t("Jewelry Price Report")}
              </h4>
            </div>
          </div>
          <div className="col-md-4">
            <div className="input__block datepicker__block">
              <label> {t("Date Range")} </label>

              <RangePicker
                className="date-range-input"
                ranges={{
                  Today: [moment(), moment()],
                  Yesterday: [
                    moment().subtract(1, "days"),
                    moment().subtract(1, "days"),
                  ],
                  "Last 7 Days": [moment().subtract(7, "days"), moment()],
                  "Last 30 Days": [moment().subtract(30, "days"), moment()],
                  "This Month": [
                    moment().startOf("month"),
                    moment().endOf("month"),
                  ],
                  "Last Month": [
                    moment().subtract(1, "month").startOf("month"),
                    moment().subtract(1, "months").endOf("month"),
                  ],
                  "Last 90 Days": [moment().subtract(90, "days"), moment()],
                  "Year To Date": [moment().startOf("year"), moment()],
                }}
                format={"MM-DD-YYYY"}
                onChange={onDateChange}
                defaultValue={[moment().subtract(30, "days"), moment()]}
                defaultPickerValue={[moment().subtract(30, "days"), moment()]}
              />
            </div>
          </div>

          <div className="col-md-4">
            <div className="input__block">
              <label> {t("Vendor(s)")} </label>
              <Select
                className="border__grey"
                showSearch
                mode="multiple"
                showArrow
                placeholder={t("Select one or more vendor")}
                optionFilterProp="children"
                value={selectedData.vendorIds}
                onChange={(e) => handleOnChange(e, "select", "vendors")}
              >
                {vendorList.map((item, key) => {
                  return (
                    <Option key={item.dealerID} value={item.dealerID}>
                      {" "}
                      {item.dealerCompany}{" "}
                    </Option>
                  );
                })}
              </Select>
            </div>
          </div>

          <div className="col-md-4">
            <div className="input__block">
              <label> {t("Retailer(s)")} </label>
              <Select
                showSearch
                showArrow
                className="border__grey"
                placeholder={t("Select one or more retailer ")}
                optionFilterProp="children"
                onChange={(e) => handleOnChange(e, "select", "retailers")}
                notFoundContent={t("No Data Found")}
                mode="multiple"
                value={selectedData.retailerIds}
              >
                {retailerList.map((item, key) => {
                  return (
                    <Option key={key} value={item.dealerID}>
                      {" "}
                      {item.dealerCompany}{" "}
                    </Option>
                  );
                })}
              </Select>
            </div>
          </div>

          <div className="col-md-4">
            <div className="input__block">
              <button className="primary-btn mt-2" onClick={applyFilterHandler}>
                {" "}
                {t("Apply Filter")}{" "}
              </button>
            </div>
          </div>

          {!showChart ? (
            <Spin spinning={showLoader}>
              <div className="col-lg-12">
                <div
                  className="chart__section"
                  style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}
                >
                  {googleChartData.length > 1 && (
                    <>
                      {/* ✅ Custom Legend - ABOVE THE CHART */}
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          justifyContent: "center",
                          marginBottom: "10px",
                        }}
                      >
                        {googleChartData.slice(1).map((row, index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              margin: "4px 8px",
                              fontSize: "13px",
                              fontWeight: "500",
                            }}
                          >
                            <div
                              style={{
                                width: "14px",
                                height: "14px",
                                backgroundColor: colorData[index],
                                marginRight: "6px",
                                borderRadius: "3px",
                              }}
                            ></div>
                            <span title={row[0].replace(/\s*\([^)]*\)\s*/g, "")}>
                              {row[0].replace(/\s*\([^)]*\)\s*/g, "")}
                            </span>
                            <span style={{ marginLeft: "4px", color: "#666" }}>
                              ({row[1]})
                            </span>
                          </div>
                        ))}
                      </div>

                      {/* ✅ Centered Doughnut Chart - BELOW LEGENDS */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          width: "100%",
                        }}
                      >
                        <Chart
                          chartType="PieChart"
                          data={googleChartData}
                          width={window.innerWidth > 500 ? "800px" : "320px"}
                          height={window.innerWidth > 500 ? "500px" : "300px"}
                          options={chartOptions}
                          chartEvents={[
                            {
                              eventName: "select",
                              callback: handleChartClick,
                            },
                          ]}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div className="col-lg-12 mt-3 d-flex flex-column flex-lg-row justify-content-lg-end mb-3">
                {/* <div className="button__block mb-4"> */}
                  <button
                    className="primary-btn mb-2 mb-lg-0 mr-2"
                    onClick={handleDownloadPieChart}
                  >
                    {" "}
                    <i className="fa fa-download"></i> {t("Download Chart")}{" "}
                  </button>
                  <Button
                    className="primary-btn"
                    onClick={handleDownloadCSVReports}
                    loading={CSVLoading}
                  >
                    {" "}
                    <i className="fa fa-download"></i> {t("Download CSV")}
                  </Button>
                {/* </div> */}
              </div>

              <div className="col-lg-12 col-md-12">
                <Table
                  className="pendjewelreq__tbl"
                  scroll={{ x: 1200, y: "calc(100vh - 340px)" }}
                  columns={columns}
                  dataSource={tableChartData}
                  loading={showTableLoader}
                  pagination={{
                    size: "small",
                    total: totalCount,
                    pageSizeOptions: [10, 15, 20, 50, 100],
                    responsive: true,
                    showSizeChanger: true,
                    pageSize: pageSize,
                    current: pageNo,
                  }}
                  onChange={handleTableASCDES}
                />
              </div>
            </Spin>
          ) : (
            <div className="no-report-render">
              <div className="desc-space">
                <h4 className="text-center">{t("No Data Found")}</h4>
              </div>
            </div>
          )}
        </div>
      </div>
      <Modal
        title=""
        centered
        visible={visible}
        onOk={() => setVisible(false)}
        onCancel={() => setVisible(false)}
        width={500}
        footer={false}
      >
        <div className="">
          <img src={selectedImage} className="img-fluid" />
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default JewelryPriceReport;